import { useEffect, useRef, useState } from "react";
import { Eraser, Check, Loader2, PenLine, RotateCcw } from "lucide-react";
import { DocImage } from "@/components/DocImage";

export const SignaturePad = ({ doc, onSave, onReset, busy }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    const r = c.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    c.width = r.width * dpr;
    c.height = r.height * dpr;
    const ctx = c.getContext("2d");
    ctx.scale(dpr, dpr);
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0b1437";
  }, [doc]);

  const pt = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture(e.pointerId); drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pt(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pt(e)); ctx.stroke(); setDirty(true); };
  const up = () => { drawing.current = false; };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setDirty(false); };
  const save = () => ref.current.toBlob((b) => b && onSave(b), "image/png");

  if (doc) return (
    <div className="rounded-xl border-2 border-emerald-500 bg-white p-2" data-testid="signature-saved">
      <DocImage docId={doc.doc_id} alt="Tanda tangan" className="h-28 w-full object-contain" testid="signature-preview" />
      <div className="flex items-center justify-between mt-1">
        <span className="flex items-center gap-1 text-[11px] font-semibold text-emerald-700"><Check className="h-3.5 w-3.5" />Tanda tangan tersimpan</span>
        <button type="button" onClick={onReset} data-testid="signature-redo" className="flex items-center gap-1 text-[11px] font-semibold text-blue-700"><RotateCcw className="h-3.5 w-3.5" />Ulangi</button>
      </div>
    </div>
  );

  return (
    <div data-testid="signature-pad">
      <div className="relative rounded-xl border-2 border-dashed border-slate-300 bg-slate-50">
        <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
          className="w-full h-32 touch-none cursor-crosshair" data-testid="signature-canvas" />
        {!dirty && <span className="absolute inset-0 flex items-center justify-center gap-1.5 text-[12px] text-slate-400 pointer-events-none"><PenLine className="h-4 w-4" />Tanda tangan di sini</span>}
        <div className="absolute left-4 right-4 bottom-6 border-b border-slate-300 pointer-events-none" />
      </div>
      <div className="flex gap-2 mt-2">
        <button type="button" onClick={clear} disabled={!dirty || busy} data-testid="signature-clear"
          className="flex-1 flex items-center justify-center gap-1.5 h-10 rounded-xl border border-slate-300 text-[13px] font-semibold text-slate-700 disabled:opacity-50"><Eraser className="h-4 w-4" />Hapus</button>
        <button type="button" onClick={save} disabled={!dirty || busy} data-testid="signature-save"
          className="flex-1 flex items-center justify-center gap-1.5 h-10 rounded-xl bg-blue-700 text-white text-[13px] font-semibold disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />}Gunakan Tanda Tangan</button>
      </div>
    </div>
  );
};
